export default "__VITE_ASSET__CQWcsKI6__"